import type { PromoFieldMode, PromoFieldMutationState } from './PromoFieldForm.types';

export function getTimeoutValue(mode: PromoFieldMode, state: PromoFieldMutationState | null) {
  if (mode === 'check') {
    if (state?.error || state?.isSuccess) {
      return 3_000;
    }
  } else if (mode === 'apply') {
    if (state?.error) {
      return 3_000;
    }

    if (state?.data) {
      return 5_000;
    }
  }

  return 7_000;
}
